// @flow
import { FormLabel, Typography } from "@mui/material";
import Box from '@mui/material/Box'
import Grid from "@mui/material/Grid2";
import { FormikProvider } from "formik";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import MultiTextField from "../../../../../components/mui/form/multiTextField/multiTextField";
import DangerouslySetHtml from "../../../../../components/mui/general/dangerouslySetHtml/dangerouslySetHtml";
import { ISSUES_FORM } from "../../../locales/namespaces";
import { v4 as uuidv4 } from "uuid";
import CollapseBox from "../../../../../components/mui/general/collapseBox/collapseBox";

type Props = {};

const SendSoEmail = (props: Props) => {
	const { emailFormik: formik } = props;
	const { t } = useTranslation(ISSUES_FORM)
	
	const onRemove = (item, index, field) => {
		const updated = _.filter(formik.values[field], (i) => item.id !== i.id);
		formik.setFieldValue(field, updated)
	}
	const onAdd = (field) => {
		const values = [...formik.values[field]]
		values.push({ id: uuidv4(), value: '' })
		formik.setFieldValue(field, values)
	}
	
	const onChange = (newValue, item, index, field) => {
		const updated = formik.values[field].map(i => ({
			...i,
			value: i.id === item.id ? newValue : i.value,
		}))
		formik.setFieldValue(`[${field}]`, updated)
	}
	return (
		<FormikProvider value={formik}>
			<Box
				component={'form'}
				autoComplete="off"
				onSubmit={formik.handleSubmit}
				sx={{
					display: 'flex',
					flexDirection: 'column',
					width: '100%',
				}}
			>
				<CollapseBox title={t('Recipients Information')}>
					<Grid container spacing={1} p={1}>
						<Grid size={12}>
							<MultiTextField
								label={'TO'}
								value={formik.values.to}
								name={'to'}
								onChange={(newValue, item, index) => {
									onChange(newValue, item, index, 'to')
								}}
								onBlur={formik.handleBlur}
								onRemove={(item, index) => {
									onRemove(item, index, 'to')
								}}
								onAdd={() => {
									onAdd('to')
								}}
							/>
						</Grid>
						<Grid size={12}>
							<MultiTextField
								label={'CC'}
								value={formik.values.cc}
								name={'cc'}
								onChange={(newValue, item, index) => {
									onChange(newValue, item, index, 'cc')
								}}
								onBlur={formik.handleBlur}
								onRemove={(item, index) => {
									onRemove(item, index, 'cc')
								}}
								onAdd={() => {
									onAdd('cc')
								}}
							/>
						</Grid>
						{/* Ζήτησαν να το κρύψουμε. Η λογική στα data συνεχίζει να υπάρχει, σε περίπτωση που το ξανά ζητήσουν. */}
						{/*<Grid size={12}>*/}
						{/*	<MultiTextField*/}
						{/*		label={'BCC'}*/}
						{/*		value={formik.values.bcc}*/}
						{/*		name={'bcc'}*/}
						{/*		onChange={(newValue, item, index) => {*/}
						{/*			onChange(newValue, item, index, 'bcc')*/}
						{/*		}}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*		onRemove={(item, index) => {*/}
						{/*			onRemove(item, index, 'bcc')*/}
						{/*		}}*/}
						{/*		onAdd={() => {*/}
						{/*			onAdd('bcc')*/}
						{/*		}}*/}
						{/*	/>*/}
						{/*</Grid>*/}
					</Grid>
				</CollapseBox>
				<Grid container spacing={1}>
					<Grid size={12}>
						<FormLabel>{t('email_subject')}</FormLabel>
						<Typography variant="subtitle2" color="textSecondary" sx={{ background: '#fefde7' }}>
							{formik.values.subject}
						</Typography>
					</Grid>
					<Grid size={12}>
						<FormLabel>{t('Body')}</FormLabel>
						<Typography variant="body1" component={'div'}>
							<DangerouslySetHtml
								htmlContent={formik.values.body}
								isProcessed={true}
								sx={{background: '#f2f8ff', p: 1, overflowX: 'auto'}}
							/>
						</Typography>
					</Grid>
				</Grid>
			</Box>
		</FormikProvider>
	);
};

export default SendSoEmail